export const CONST_SCREENS = [
  '62a169d141ed409c7b0db4e9',
  '62a169f241ed409c7b0db4ea',
  '62a16a0241ed409c7b0db4eb',
  '62a16a1041ed409c7b0db4ec',
  '62a16a3e41ed409c7b0db4ed',
  '62a16a4a41ed409c7b0db4ee',
  '62a16a5d41ed409c7b0db4ef',
]
